import Vue from 'vue';
import api from '../bu/api';

export default {
	namespaced: true,

	state: () => ({
		interstitials: {}
	}),

	getters: {
		interstitials(state) {
			return Object.values(state.interstitials);
		},
		interstitialMap(state) {
			return state.interstitial;
		}
	},

	actions: {
		async getInterstitials({commit}) {
			const response = await api.getInterstitials();
			commit('setInterstitials', response.data);
			return response.data.map((interstitial) => interstitial.id);
		},
		async deleteInterstitial({commit}, interstitialId) {
			const response = await api.deleteInterstitial(interstitialId);
			commit('deleteInterstitial', interstitialId);
		},
		async saveInterstitial({commit}, { interstitial, photoFile }) {
			const response = await api.saveInterstitial(interstitial, photoFile);
			commit('setInterstitial', response.data);
			return response.data;
		},
	},

	mutations: {
		setInterstitial(state, interstitial) {
			Vue.set(state.interstitials, interstitial.id, interstitial);
		},
		setInterstitials(state, interstitials) {
			interstitials.forEach((interstitial) => {
				Vue.set(state.interstitials, interstitial.id, interstitial);
			});
		},
		deleteInterstitial(state, interstitialId) {
			Vue.delete(state.interstitials, interstitialId);
		}
	},
}